import React, { useEffect } from "react";
import { useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Table, Modal } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import Endpoints from "../../api/endpoints.js";
import PageRoutes from "../../utils/routes.js";
import useSuccessErrorModal from "../../hooks/successErrorModal/useSuccessErrorModal";
import EndpointFunctions from "../../utils/Functions/endpointFunctions.js";
import { OtherCardColumns } from "./OtherCardColumns.js";

const OtherCards = () => {
  const { showModal, closeModal, ModalComponent } = useSuccessErrorModal();
  const [tableData, setTableData] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);

  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  useEffect(() => {
    fetchOtherCardsData();
  }, []);

  const fetchOtherCardsData = async () => {
    setTableLoading(true);
    const result = await EndpointFunctions.fetchData({
      endpointURL: Endpoints.getAllOtherCards,
      axiosPrivate: axiosPrivate,
    });

    if (result.success) {
      const otherCardsData = result.data;
      setTableData(() => otherCardsData);
      setTableLoading(false);
    } else {
      setTableLoading(false);
      showModal(result.errorTitle, result.errorMessage, () => {
        closeModal();
      });
    }
  };

  const goToUpdatePage = ({ record }) => {
    const id = record.id;
    let path = `${PageRoutes.updateOtherCard}/${id}`;
    navigate(path);
  };

  const deleteOtherCard = ({ record }) => {
    const id = record.id;
    Modal.confirm({
      title: "Kartı Sil",
      icon: <ExclamationCircleFilled />,
      content: `Kart ID:${record.id} - ${record.companyName} silinecektir. Emin misiniz?`,
      onOk() {
        return new Promise((resolve, reject) => {
          EndpointFunctions.deleteRecord({
            recordId: id,
            axiosPrivate: axiosPrivate,
            endpointURL: Endpoints.deleteOtherCard,
          })
            .then((response) => {
              resolve();
              if (response.success) {
                showModal("Başarılı", "Kart Silindi.", () => {
                  closeModal();
                });
                setTableLoading(true);
                fetchOtherCardsData();
              } else {
                showModal(response.errorTitle, response.errorMessage, () => {
                  closeModal();
                });
              }
            })
            .catch((err) => {
              showModal("Hata", "İşlem sırasında bir hata oluştu.", () => {
                closeModal();
              });
              reject(err);
            });
        });
      },
    });
  };

  return (
    <>
      <Table
        dataSource={tableData}
        columns={OtherCardColumns(goToUpdatePage, deleteOtherCard)}
        scroll={{ x: true }}
        loading={tableLoading}
      />

      <ModalComponent></ModalComponent>
    </>
  );
};

export default OtherCards;
